import React from 'react';
import ContentLoader from 'react-content-loader';

const ListLoading = () => (
  <ContentLoader
    height={400}
    width={400}
    speed={1}
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
  >
    <rect x="0" y="10" rx="0" ry="0" width="65" height="65" />
    <rect x="0" y="100" rx="3" ry="3" width="200" height="17" />
    <rect x="0" y="130" rx="3" ry="3" width="170" height="17" />
    <rect x="0" y="160" rx="3" ry="3" width="220" height="17" />
    <rect x="0" y="190" rx="3" ry="3" width="150" height="17" />
    <rect x="0" y="250" rx="0" ry="0" width="65" height="65" />
    <rect x="0" y="345" rx="3" ry="3" width="150" height="17" />
    <rect x="0" y="375" rx="3" ry="3" width="200" height="17" />
  </ContentLoader>
);

export default ListLoading;
